import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import { getIn, useFormikContext } from 'formik';
import { isEqual } from 'lodash';

/**
 * An undo icon for Formik field `name`, shown only while the field differs from its starting
 * value; clicking it puts back just that field's starting value. Used in the admin drawers'
 * field labels (AdminFieldLabel) and section headings.
 */
export const UndoFieldButton = ({ name }) => {
	const { values, initialValues, setFieldValue } = useFormikContext();
	const initialValue = getIn(initialValues, name);

	if (isEqual(getIn(values, name), initialValue)) {
		return null;
	}

	return (
		<Tooltip title='Undo change'>
			<IconButton
				size='small'
				aria-label='Undo change'
				onClick={() => setFieldValue(name, initialValue)}
				// Small enough not to make the label row taller when it appears
				sx={{ p: 0 }}
			>
				<UndoIcon sx={{ fontSize: 18 }} />
			</IconButton>
		</Tooltip>
	);
};
